/* eslint-disable import/prefer-default-export */

export const getLoadingStatus = (state) => state.customPages.loadingStatus;
export const getSavingStatus = (state) => state.customPages.savingStatus;
export const getCustomPagesApiStatus = (state) => state.customPages.customPagesApiStatus;
// export const getCourseAppSettingValue = (setting) => (state) => (
//   state.pagesAndResources.courseAppSettings[setting]?.value
// );
